export default __webpack_public_path__ + "static/media/admit.db80dccc.png";